import { Theme as RadixTheme } from "@radix-ui/themes";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { theme as themeConfig } from "./Theme";

const lightTheme = createTheme(themeConfig);

/**
 * The public surfaces — login, register, onboarding — are always light, regardless of
 * the theme the user picked for the back office. This wraps them in both providers
 * they need.
 *
 * Radix's <Theme> is here rather than around the whole app in index.js on purpose.
 * Its stylesheet sets `.radix-themes { color: var(--gray-12) }`, which resolves to
 * #1c2024 in its light appearance, and it never follows react-admin's theme. Applied
 * globally, every MUI text that inherits its colour — Typography without an explicit
 * `color`, such as a FormControlLabel label — came out dark on react-admin's dark
 * background.
 *
 * These pages do depend on that inherited colour: several of their texts carry no
 * colour class (see LogoAndTextComponent in register.js), so they would turn white on
 * a light card without it. Scoping the provider keeps them intact while letting the
 * back office follow its own theme.
 *
 * Note PasswordDialog needs its own wrapper even though it renders from
 * MultiStepForm: it is a Dialog, so it portals to document.body and escapes this
 * subtree.
 */
export const LightSurface = ({ children }) => (
  <ThemeProvider theme={lightTheme}>
    <RadixTheme>{children}</RadixTheme>
  </ThemeProvider>
);

export default LightSurface;
